import { render, staticRenderFns } from "./InfoOutline.vue?vue&type=template&id=32d3f352&"
import script from "./InfoOutline.vue?vue&type=script&lang=ts&"
export * from "./InfoOutline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports